// Format minutes as human-readable short string. e.g. 5 -> "5 MIN", 60 -> "1 HR", 90 -> "1H 30M", 1440 -> "1 DAY"
export const formatLeadTime = (minutes) => {
  if (!minutes || minutes <= 0) return null;
  if (minutes < 60) return `${minutes} MIN`;
  if (minutes % 1440 === 0) {
    const d = minutes / 1440;
    return `${d} ${d === 1 ? "DAY" : "DAYS"}`;
  }
  if (minutes % 60 === 0) {
    const h = minutes / 60;
    return `${h} ${h === 1 ? "HR" : "HRS"}`;
  }
  if (minutes > 60) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}H ${m}M`;
  }
  return `${minutes} MIN`;
};

// Build the reminder-flash message by prefixing the user message with "IN X MINUTES / HOURS / DAYS"
export const buildReminderMessage = (message, minutes) => {
  const lead = formatLeadTime(minutes) || "SOON";
  return `IN ${lead} · ${message}`;
};
